import { Icon } from '@mxenabled/mxui'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

import { useGlobalCopyStore } from '../../common'

export type TrendsTabValue = 'Chart' | 'Table'

interface TrendsViewToggleProps {
  selectedTab: TrendsTabValue
  onTabChange: (_event: React.SyntheticEvent, newValue: TrendsTabValue) => void
}

const TrendsViewToggle: React.FC<TrendsViewToggleProps> = ({ selectedTab, onTabChange }) => {
  const { common: copy } = useGlobalCopyStore()
  return (
    <ToggleButtonGroup
      aria-label={copy.view_toggle}
      exclusive={true}
      onChange={onTabChange}
      orientation="horizontal"
      value={selectedTab}
    >
      {['Chart', 'Table'].map((tab) => (
        <ToggleButton
          aria-label={tab === 'Chart' ? copy.view_chart : copy.view_table}
          aria-pressed={selectedTab === tab}
          color="primary"
          key={tab}
          sx={{ width: 56 }}
          value={tab}
        >
          {tab === 'Chart' ? (
            <Icon name="table_chart_view" />
          ) : (
            <Icon name="format_list_bulleted" />
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default TrendsViewToggle
